import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Communication from "components/communication";
import { Pages } from "components/pages";
import { PermissionGuard } from "components/permissions";

const CommunicationsRoute: React.FC = () => (
  <PermissionGuard
    permission={Communication.Const.permissions.VIEW}
    fallback={<Pages.Page403 />}
  >
    <Routes>
      <Route path="/" element={<Pages.Communications />} />
      <Route path="/page/:pageNum" element={<Pages.Communications />} />
      <Route path="/pending" element={<Pages.Communications />} />
      <Route path="/pending/page/:pageNum" element={<Pages.Communications />} />
      <Route path="/unidentified" element={<Pages.Communications />} />
      <Route path="/unidentified/page/:pageNum" element={<Pages.Communications />} />
      <Route path="/audit" element={<Pages.Communications />} />
      <Route path="/audit/page/:pageNum" element={<Pages.Communications />} />
      <Route path="*" element={<Navigate to={Communication.Const.basePath} replace />} />
    </Routes>
  </PermissionGuard>
);

export default CommunicationsRoute;
